export const MODAL_HIDE = 'hide';
export const MODAL_ROOT_ID = '__modal-root';
export const MODAL_SHOW = 'show';
